import React, { useContext } from 'react';
import {
  CopyOutlined,
  DeleteOutlined,
  EditOutlined,
  EllipsisOutlined,
} from '@ant-design/icons';
import { Button, Dropdown, MenuProps } from 'antd';

import IBTooltip from '@totem/components/common/helpTooltips/IBTooltip';
import { permissions } from '@totem/components/userContext/security/permissions/permissions';
import UserProfileContext from '@totem/components/userContext/UserProfileContext';
import { APIConfiguration } from '@totem/types/nozomi';

import '../../services.css';

export interface Props {
  apiConfig: APIConfiguration;
  onEdit: (apiConfig: APIConfiguration) => void;
  onCopy: (apiConfig: APIConfiguration) => void;
  onDelete: (apiConfig: APIConfiguration) => void;
}

const NozomiProvisioningActionMenu = ({
  apiConfig,
  onEdit,
  onCopy,
  onDelete,
}: Props) => {
  const { userProfile } = useContext(UserProfileContext);

  const getActionMenuItems = (): MenuProps['items'] => {
    const menuItems: MenuProps['items'] = [];

    if (
      permissions.threatDetectionConfigurationAdministrator.hasPermissions(
        userProfile,
      )
    ) {
      menuItems.push({
        key: 'edit',
        label: (
          <IBTooltip
            content={
              permissions.threatDetectionConfigurationAdministrator.tooltip
            }
          >
            Edit
          </IBTooltip>
        ),
        title: 'Edit',
        icon: <EditOutlined />,
      });

      menuItems.push({
        key: 'copy',
        label: (
          <IBTooltip
            content={
              permissions.threatDetectionConfigurationAdministrator.tooltip
            }
          >
            Copy
          </IBTooltip>
        ),
        title: 'Copy',
        icon: <CopyOutlined />,
      });

      menuItems.push({
        key: 'delete',
        label: (
          <IBTooltip
            content={
              permissions.threatDetectionConfigurationAdministrator.tooltip
            }
          >
            Delete
          </IBTooltip>
        ),
        title: 'Delete',
        icon: <DeleteOutlined />,
      });
    }

    return menuItems;
  };

  const onMenuClicked = ({ key }) => {
    // eslint-disable-next-line default-case
    switch (key) {
      case 'edit':
        onEdit(apiConfig);
        break;
      case 'copy':
        onCopy(apiConfig);
        break;
      case 'delete':
        onDelete(apiConfig);
        break;
    }
  };

  return (
    <>
      <Dropdown
        menu={{ items: getActionMenuItems(), onClick: onMenuClicked }}
        trigger={['click']}
      >
        <Button shape="circle" icon={<EllipsisOutlined />} />
      </Dropdown>
    </>
  );
};

export default NozomiProvisioningActionMenu;
